<template>
  <Stack tag="div" gap="xs">
    <Icon
      v-if="availability !== 'outOfStock'"
      :name="USPS[availability].icon"
      :size="16"
      class="ui-mt-3xs"
    />

    <Stack tag="div" gap="none" direction="col">
      <Text tag="p" size="caption" weight="bold">
        {{ USPS[availability].title }}
      </Text>

      <Stack tag="div" align="start" gap="2xs">
        <div
          v-if="indication"
          class="!ui-w-[10px] !ui-h-[10px] ui-aspect-square ui-rounded-[100%] ui-mt-3xs"
          :class="indicatorClass"
        />
        <Stack tag="div" gap="none" direction="col">
          <Text tag="p" size="caption" class="z-10">
            {{ availabilityReason || USPS[availability].description }}
            <Text
              v-if="immediatelyCollectable"
              weight="bold"
              size="xs"
              class="ui-text-mkm-blue-light cursor-pointer ui-bg-transparent ui-z-10"
              @click="emit('open:branchTray')"
            >
              See opening hours
            </Text>
            <Text
              v-if="dropshipLink && availability === 'dropship'"
              @click="emit('open:dropship')"
              size="xs"
              weight="bold"
              class="ui-text-mkm-blue-light ui-leading-xs cursor-pointer"
              data-test-id="dropShipTray-Link"
              data-fs="dropShipTray-Link"
            >
              Find Out More
            </Text>
          </Text>
        </Stack>
      </Stack>
    </Stack>
  </Stack>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import Icon from "../Icon/Icon.vue";
import { IconName } from "../Icon/types";
import Stack from "../Layout/Stack/Stack.vue";
import Text from "../Typography/Text/Text.vue";
import { CardUSPProps } from "./types";

const emit = defineEmits<{
  (event: "open:dropship"): void;
  (event: "open:branchTray"): void;
}>();

const props = defineProps<CardUSPProps>();

const immediatelyCollectable = computed(
  () => props.availabilityReason?.includes("1 hour"),
);

const indication = computed(() => {
  return (
    props.availability === "collect" ||
    props.availability === "quote" ||
    props.availability === "outOfStock"
  );
});

const indicatorClass = computed(() => {
  if (props.availability === "collect" || props.availability === "delivery") {
    return "ui-bg-green-default";
  }
  return "ui-bg-orange-default";
});

type USPType = {
  icon: IconName;
  title: string;
  description: string;
};

type USPSType = {
  collect: USPType;
  delivery: USPType;
  quote: USPType;
  dropship: USPType;
  outOfStock: USPType;
};

const USPS: USPSType = {
  collect: {
    icon: "pointer-blue",
    title: "FREE Click & Collect",
    description: "Available to order",
  },
  delivery: {
    icon: "truck",
    title: "FREE local delivery",
    description: "Restrictions apply*",
  },
  quote: {
    icon: "pointer-blue",
    title: "FREE Click & Collect",
    description: "Available by quote only",
  },
  dropship: {
    icon: "package",
    title: "FREE Delivery* available",
    description: "Delivered by one of our trusted suppliers.",
  },
  outOfStock: {
    icon: "add-star",
    title: "Item is not currently available",
    description: "Contact branch for alternative or availability",
  },
};
</script>
